export const DEVICE_RESOLUTIONS: ExecutionContainerOption[] = [
    { name: "Device BlackBerry Z30", value: "Device:BlackBerry_Z30" },
    { name: "Device Blackberry PlayBook", value: "Device:Blackberry_PlayBook" },
    { name: "Device Galaxy Z Fold 5", value: "Device:Galaxy_Z_Fold_5" },
    { name: "Device Galaxy Note 3", value: "Device:Galaxy_Note_3" },
    { name: "Device Galaxy Note II", value: "Device:Galaxy_Note_II" },
    { name: "Device Galaxy S III", value: "Device:Galaxy_S_III" },
    { name: "Device Galaxy S5", value: "Device:Galaxy_S5" },
    { name: "Device Galaxy S8", value: "Device:Galaxy_S8" },
    { name: "Device Galaxy S9+", value: "Device:Galaxy_S9+" },
    { name: "Device Samsung Galaxy S8+", value: "Device:Samsung_Galaxy_S8+" },
    { name: "Device Samsung Galaxy S20 Ultra", value: "Device:Samsung_Galaxy_S20_Ultra" },
    { name: "Device Samsung Galaxy A51/71", value: "Device:Samsung_Galaxy_A51_A71" },
    { name: "Device Galaxy Tab S4", value: "Device:Galaxy_Tab_S4" },
    { name: "Device Kindle Fire HDX", value: "Device:Kindle_Fire_HDX" },
    { name: "Device LG Optimus L70", value: "Device:LG_Optimus_L70" },
    { name: "Device Microsoft Lumia 550", value: "Device:Microsoft_Lumia_550" },
    { name: "Device Microsoft Lumia 950", value: "Device:Microsoft_Lumia_950" },
    { name: "Device Moto G Power", value: "Device:Moto_G_Power" },
    { name: "Device Moto G4", value: "Device:Moto_G4" },
    { name: "Device Nexus 10", value: "Device:Nexus_10" },
    { name: "Device Nexus 4", value: "Device:Nexus_4" },
    { name: "Device Nexus 5", value: "Device:Nexus_5" },
    { name: "Device Nexus 5X", value: "Device:Nexus_5X" },
    { name: "Device Nexus 6", value: "Device:Nexus_6" },
    { name: "Device Nexus 6P", value: "Device:Nexus_6P" },
    { name: "Device Nexus 7", value: "Device:Nexus_7" },
    { name: "Device Nokia Lumia 520", value: "Device:Nokia_Lumia_520" },
    { name: "Device Nokia N9", value: "Device:Nokia_N9" },
    { name: "Device Pixel 2", value: "Device:Pixel_2" },
    { name: "Device Pixel 2 XL", value: "Device:Pixel_2_XL" },
    { name: "Device Pixel 3", value: "Device:Pixel_3" },
    { name: "Device Pixel 3 XL", value: "Device:Pixel_3_XL" },
    { name: "Device Pixel 4", value: "Device:Pixel_4" },
    { name: "Device Pixel 7", value: "Device:Pixel_7" },
    { name: "Device JioPhone 2", value: "Device:JioPhone_2" },
    { name: "Device iPhone SE", value: "Device:iPhone_SE" },
    { name: "Device iPhone XR/11", value: "Device:iPhone_XR_11" },
    { name: "Device iPhone 12/13 Pro", value: "Device:iPhone_12_13_Pro" },
    { name: "Device iPhone 14 Pro Max", value: "Device:iPhone_14_Pro_Max" },
    { name: "Device iPhone 4", value: "Device:iPhone_4" },
    { name: "Device iPhone 5/SE", value: "Device:iPhone_5_SE" },
    { name: "Device iPhone 6/7/8", value: "Device:iPhone_6_7_8" },
    { name: "Device iPhone 6/7/8 Plus", value: "Device:iPhone_6_7_8_Plus" },
    { name: "Device iPhone X/XS", value: "Device:iPhone_X_XS" },
    // { name: "Device iPhone 11 Pro", value: "Device:iPhone_11_Pro" },
    // { name: "Device iPhone 11 Pro Max", value: "Device:iPhone_11_Pro_Max" },
    // { name: "Device iPhone 12/13 mini", value: "Device:iPhone_12_13_mini" },
    // { name: "Device iPhone SE 2nd gen", value: "Device:iPhone_SE_2nd_gen" },
    // { name: "Device iPhone XS Max", value: "Device:iPhone_XS_Max" }
];